import axios from "axios"

// The verification code is generated and validated server-side. The client only
// asks the API to send a code to the phone number; it never knows or chooses the
// code. (Previously the client generated the code and compared it locally, which
// allowed trivial account takeover.)
export const sendTextMessage = (phoneNumber) => {
    return axios.post(process.env.REACT_APP_API_URL + '/sendMessage', {
        to: phoneNumber,
    });
}
